import { useMutation } from '@tanstack/react-query';

import { register } from '../api/auth.api';

/** Create an account. Success does NOT sign in — the user must verify the OTP. */
export function useRegister() {
  return useMutation({ mutationFn: register });
}
